import React from 'react';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';

import { t } from 'i18next';

import {
  Box, LinearProgress, styled,
  Button, KeyIcon, Typography,
} from '@datanomik/commons-ui';

import { UserShared2Line, CheckLine } from '@datanomik/commons-ui/icons';

import { useUserContext } from '@/contexts/user';

import { styles } from './styles';
import { useActivateWorkspace } from './hooks';

const ActivateWorkspaceRaw = ({ className, onClose }) => {
  const navigateRedirect = useNavigate();
  const { userIsLogged } = useUserContext();
  const { activating } = useActivateWorkspace();

  const handleRedirect = () => {
    navigateRedirect('/');
    window.location.reload();
  };

  const handleCloseWorkspace = () => {
    onClose();
    window.location.reload();
  };

  return (
    <Box sx={{ height: '100vh' }} className={className}>
      {userIsLogged() ? (
        <Box>
          {activating ? (
            <Box>
              <Typography variant="h5">
                {t('Workspace is being activated')}
              </Typography>
              <Box mt="30px">
                <LinearProgress sx={{ height: '2px' }} />
              </Box>
            </Box>
          ) : (
            <Box>
              <KeyIcon size="xlarge" variant="ligther" color="success">
                <CheckLine />
              </KeyIcon>
              <Typography variant="h5" mt="16px" mb="24px">
                {t('Workspace successfully activated!')}
              </Typography>

              {onClose ? (
                <Button onClick={handleCloseWorkspace}>
                  {t('Close')}
                </Button>
              ) : (
                <Button onClick={handleRedirect}>
                  {t('Back to home page')}
                </Button>
              )}
            </Box>
          )}
        </Box>
      ) : (
        <Box>
          <KeyIcon size="xlarge">
            <UserShared2Line />
          </KeyIcon>
          <Typography variant="h5" mt="16px" mb="24px">
            {t('Please login to activate the workspace.')}
          </Typography>
          <Button onClick={handleRedirect}>
            {t('Back to login page')}
          </Button>
        </Box>
      )}
    </Box>
  );
};

ActivateWorkspaceRaw.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
};

export const ActivateWorkspacePage = styled(ActivateWorkspaceRaw)(styles);
ActivateWorkspacePage.propTypes = ActivateWorkspaceRaw.propTypes;

export const ActivateWorkspacePublic = () => (
  <ActivateWorkspacePage />
);
